// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.finalesContainer {
    background-color: #0C0B20;
    color: #FFFFFF;
    font-family: 'Lato', sans-serif;
}

.finalesContainer .filterButtons {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
}

.finalesContainer .semiFinaleBtn,
.finalesContainer .finaleBtn {
    display: flex;
    padding: 8px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    color: #0C0B20;
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 12px */
    border-radius: 4px;
    border: 1px solid #69C3C5;
    background: none;
    color: #69C3C5;
    cursor: pointer;
}

.finalesContainer .filterButtons button.active {
    border-radius: 4px;
    border: 1px solid #69C3C5;
    background: #69C3C5;
    color: #0C0B20;
}

.finalesContainer .filterButtons button:hover {
    background: #69C3C5;
    color: #0C0B20;
    transition: background-color 0.3s, color 0.3s;
}

.finalesContainer .matchItem {
    background-color: #1F1E3D;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #FFFFFF;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
}

.finalesContainer .matchItem h3 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 8px;
    color: #69C3C5;
}

.finalesContainer .matchItem p {
    margin: 4px 0;
    font-size: 14px;
}

.finalesContainer p {
    margin: 0;
    padding: 0;
}

.finalesContainer p:last-child {
    margin-bottom: 0;
}

.finalesContainer .matchItem:hover {
    background-color: #2A2951;
    transition: background-color 0.3s;
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/Finales.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC","sourcesContent":[".finalesContainer {\r\n    background-color: #0C0B20;\r\n    color: #FFFFFF;\r\n    font-family: 'Lato', sans-serif;\r\n}\r\n\r\n.finalesContainer .filterButtons {\r\n    display: flex;\r\n    gap: 12px;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.finalesContainer .semiFinaleBtn,\r\n.finalesContainer .finaleBtn {\r\n    display: flex;\r\n    padding: 8px 12px;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 4px;\r\n    color: #0C0B20;\r\n    text-align: center;\r\n    font-family: Lato;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 100%; /* 12px */\r\n    border-radius: 4px;\r\n    border: 1px solid #69C3C5;\r\n    background: none;\r\n    color: #69C3C5;\r\n    cursor: pointer;\r\n}\r\n\r\n.finalesContainer .filterButtons button.active {\r\n    border-radius: 4px;\r\n    border: 1px solid #69C3C5;\r\n    background: #69C3C5;\r\n    color: #0C0B20;\r\n}\r\n\r\n.finalesContainer .filterButtons button:hover {\r\n    background: #69C3C5;\r\n    color: #0C0B20;\r\n    transition: background-color 0.3s, color 0.3s;\r\n}\r\n\r\n.finalesContainer .matchItem {\r\n    background-color: #1F1E3D;\r\n    border-radius: 8px;\r\n    padding: 16px;\r\n    margin-bottom: 12px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    color: #FFFFFF;\r\n    font-family: 'Lato', sans-serif;\r\n    font-size: 14px;\r\n}\r\n\r\n.finalesContainer .matchItem h3 {\r\n    font-size: 18px;\r\n    font-weight: 700;\r\n    margin-bottom: 8px;\r\n    color: #69C3C5;\r\n}\r\n\r\n.finalesContainer .matchItem p {\r\n    margin: 4px 0;\r\n    font-size: 14px;\r\n}\r\n\r\n.finalesContainer p {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.finalesContainer p:last-child {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.finalesContainer .matchItem:hover {\r\n    background-color: #2A2951;\r\n    transition: background-color 0.3s;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
